<script>
export const group = 'Full'
</script>

<script setup>
import JOEBackground3 from '../../../assets/animations/joe/backgrounds/joe_background_3.webm'
import Transition4 from './transitions/Transition4.vue'
import TextSlideUpFade from './text_animations/TextSlideUpFade.vue'
const gsapTimeline = useGsapTimeline()

const { item } = defineProps({
  item: Object,
})

const upcomingShowsElement = ref(null)
const imageElements = ref(null)
const dotElement = ref(null)

const timeTimelines = ref([])
const titleTimelines = ref([])

onMounted(() => {
  const timeline = gsapTimeline({ name: 'UpcomingShows', delay: frames(40, 50) })
    .from(upcomingShowsElement, { yPercent: 100, duration: frames(55, 50), ease: 'power2.out' })
    .from(imageElements.value, { scale: 0.75, duration: frames(20, 50), stagger: frames(8, 50), ease: 'power2.inOut' }, `<${frames(20, 50)}`)
    .add(timeTimelines, '<')
    .add(titleTimelines, '<')

  timeTimelines.value.forEach((timeTimeline, i) => {
    timeline.add(timeTimeline, `<${frames(3, 50) + i * frames(4, 50)}`)
    timeline.add(titleTimelines.value[i], `<${frames(3, 50) + i * frames(4, 50)}`)
  })

  timeline.from(dotElement, { scale: 0, duration: frames(20, 50), ease: 'power2.out', yoyo: true, repeat: -1, repeatDelay: frames(40, 50) }, `<${frames(6, 50)}`)
})

const previousShow = computed(() => item.enrichment.upcomingShows.find((show) => show.relative_to_now === -1))
const currentShow = computed(() => item.enrichment.upcomingShows.find((show) => show.relative_to_now === 0))
const nextShow = computed(() => item.enrichment.upcomingShows.find((show) => show.relative_to_now === 1))

const formatTime = (isoString) => {
  const date = new Date(isoString)
  const hours = date.getHours().toString().padStart(2, '0')
  const minutes = date.getMinutes().toString().padStart(2, '0')
  return `${hours}:${minutes}`
}

const imageForShow = (show) => show.header_images.visual_radio_upcoming_show || show.header_images.site_carousel
</script>

<template>
  <Transition4>
    <div class="size-full bg-joe-cr-blue-primary">
      <VideoPlayer :src="JOEBackground3" class="absolute size-full object-cover" autoplay muted loop />

      <div ref="upcomingShowsElement" class="relative size-full flex items-center">
        <div v-for="show in [previousShow, currentShow, nextShow]" :key="show.id" class="w-1/3 flex flex-col items-center">
          <div class="mb-10 aspect-[4/5]" :class="show === currentShow ? 'w-full' : 'w-[500px] mt-16'">
            <img v-if="imageForShow(show)" ref="imageElements" :src="imageForShow(show).url" class="size-full object-cover rounded-[6rem]" />
          </div>

          <div class="text-white flex flex-col items-center space-y-3">
            <TextSlideUpFade
              :text="show === currentShow ? `Nu op de radio` : `${formatTime(show.start_time)} - ${formatTime(show.stop_time)} uur`"
              class="text-[2rem]"
              @timeline="timeTimelines.push($event)"
            />

            <div class="flex items-center space-x-5">
              <div v-if="show === currentShow" ref="dotElement" class="rounded-full size-4 bg-joe-cr-rose-primary" />
              <TextSlideUpFade :text="show.title" class="text-5xl font-bold" @timeline="titleTimelines.push($event)" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </Transition4>
</template>
